<template>
  <div class="cpc-create">
    <breadcrumbs :breadcrumbsData="breadcrumbsData" #icon>
    </breadcrumbs>

    <!-- <h2 class="title">{{ pageTitle }}</h2> -->

   

    <a-steps :current="currentStep" class="steps">
      <a-step v-for="(titleKey, idx) in CPC_CREATE_STEP_TITLE_KEYS" :key="titleKey" :title="$t(titleKey)">
        <template #icon>
          <span class="cpc-step-index">{{ idx + 1 }}</span>
        </template>
      </a-step>
    </a-steps>
    <noticeTool  v-if="currentStep === 0||currentStep ===2"/>
    <!-- <div class="notice">
        <p>Notice:</p>
        <p>1. The campaign will automatically end when the end time is reached or the budget cap is met.</p>
        <p>2. Different budget caps can be set for different publishers.</p>
      </div> -->
    <div class="box">
      <div v-show="currentStep === 0" class="panel">
       
        <div class="form-title">
          {{ $t('seller.accBonusProgram.creact.stepSetupProgramInfo') }}
        </div>
        <div class="form-content">
          <div class="field field-title" :class="{ 'field-error': !!step1Errors.title }">
            <label>{{ $t('seller.accBonusProgram.creact.labelProgramTitle') }}<span class="label-required">*</span></label>
            <div class="title-input-row">
              <a-input class="title-input"
               :placeholder="$t('seller.accBonusProgram.creact.placeholderProgramTitle')"
               v-model:value="form.title"
                :maxlength="100" 
                show-count />
              <!-- <span class="tips">({{ form.title.length }}/100)</span> -->
            </div>
            <p v-if="step1Errors.title" class="field-error-text">{{ step1Errors.title }}</p>
          </div>


          <div class="field" :class="{ 'field-error': !!step1Errors.brandId }">
            <label>{{ $t('seller.accBonusProgram.creact.labelSelectBrand') }}<span class="label-required">*</span></label>
            <div class="title-input-row brand-select-row">
              <BrandSelect type='accBonusProgram' v-model="form.brandId" :placeholder="$t('seller.accBonusProgram.creact.placeholderSelectBrand')"
                :show-all="false" :show-amazon-name="true"/>
            </div>
            <p v-if="step1Errors.brandId" class="field-error-text">{{ step1Errors.brandId }}</p>
          </div>
          <div class="bonus-rule-label">
            <div class='bonus-rule-label-text'>{{ $t('seller.accBonusProgram.creact.labelBonusRule') }}</div>
            <a-tooltip
             >
              <template #title>
                <div>{{ $t('seller.accBonusProgram.creact.bonusRuleTooltip1') }}</div>
                <div>{{ $t('seller.accBonusProgram.creact.bonusRuleTooltip2') }}</div>
                <div>{{ $t('seller.accBonusProgram.creact.bonusRuleTooltip3') }}</div>
              </template>
              <Icon name="wenhao-tianchong" class="bonus-rule-help" />
            </a-tooltip>
          </div>
          <div class="field field-bonus-rule"
            :class="{ 'field-error': !!step1Errors.bonusRule || !!step1Errors.fixedCpsRate || !!step1Errors.tiers }">


            <div class="bonus-rule-type-row" ref="bonusRuleTypeRef"> 
              <artmisads-select v-model:value="form.bonusRuleType" class="bonus-rule-type-select"
                :getPopupContainer="() => $refs.bonusRuleTypeRef"
                @change="onBonusRuleTypeChange" style="width: 248px;">
                <a-select-option value="fixed">{{ $t('seller.accBonusProgram.creact.optionFixedRate') }}</a-select-option>
                <a-select-option value="tier">{{ $t('seller.accBonusProgram.tierRates') }}</a-select-option>
              </artmisads-select>

              <template v-if="form.bonusRuleType === 'fixed'">
                <div class="fixed-rate-input with-suffix">
                  <a-input-number style="width: 248px;height: 32px;" v-model:value="form.fixedCpsRate" :min="0.01"
                    :max="100" :precision="2" :controls="true" :placeholder="$t('seller.accBonusProgram.creact.placeholderPleaseEnter')" />

                  <span class="suffix">%</span>
                </div>
              </template>
            </div>
            <!-- fixed/tier -->
            <div v-if="form.bonusRuleType === 'tier'" class="tier-rates-panel">
              <div v-for="(tier, index) in form.tiers" :key="tier.tierLevel" class="tier-row">
                <span class="tier-label">{{ $t('seller.accBonusProgram.creact.tierLabel', { level: tier.tierLevel }) }}</span>
                <div class="tier-field" :class="{ 'field-error': !!tierTargetSalesErrors[index] }">
                  <span class="tier-field-label">{{ $t('seller.accBonusProgram.colTargetSales') }}</span>
                  <div class="tier-rate-input with-suffix" style="margin-top: 0;">
                  <a-input-number style="width: 248px;height: 32px;" v-model:value="tier.targetSales" :min="0"
                    :precision="2" :controls="true" :placeholder="$t('seller.accBonusProgram.creact.placeholderPleaseEnter')" class="tier-input"
                    @change="() => onTierTargetSalesChange(index)" />
                    <span class="suffix">$</span>
                  </div>
                  <p v-if="tierTargetSalesErrors[index]" class="field-error-text tier-field-error">
                    {{ tierTargetSalesErrors[index] }}
                  </p>
                </div>
                <div class="tier-field tier-field-rate">
                  <span class="tier-field-label">{{ $t('seller.accBonusProgram.colBonusRate') }}</span>
                  <div class="tier-rate-input with-suffix">
                    <a-input-number style="width: 248px;height: 32px;" v-model:value="tier.bonusRate" :min="0.01"
                      :max="100" :precision="2" :controls="true" :placeholder="$t('seller.accBonusProgram.creact.placeholderPleaseEnter')" class="tier-input" />
                    <span class="suffix">%</span>
                  </div>
                </div>
                <div v-if="index === form.tiers.length - 1" class="tier-actions">
                  <button type="button" class="tier-btn tier-btn-add" :disabled="form.tiers.length >= MAX_TIERS"
                    @click="addTier">
                    {{ $t('seller.accBonusProgram.creact.addTier') }}
                  </button>
                  <button v-if="form.tiers.length > MIN_TIERS" type="button" class="tier-btn tier-btn-delete"
                    @click="removeTier">
                    {{ $t('seller.accBonusProgram.creact.deleteTier') }}
                  </button>
                </div>
              </div>
            </div>
            <p class="platform-fee-note">{{ $t('seller.accBonusProgram.creact.platformFeeNote') }}</p>
            <p v-if="step1Errors.bonusRule" class="field-error-text">{{ step1Errors.bonusRule }}</p>
            <p v-if="step1Errors.fixedCpsRate" class="field-error-text">{{ step1Errors.fixedCpsRate }}</p>
            <p v-if="step1Errors.tiers" class="field-error-text">{{ step1Errors.tiers }}</p>
          </div>

          <div class="row">
            <div class="field" style="margin-bottom: 20px;margin-top: 0;"
              :class="{ 'field-error': !!step1Errors.startDateTimestamp }">
              <label>{{ $t('seller.accBonusProgram.creact.labelStartDate') }}<span class="label-required">*</span></label>
              <a-date-picker v-model:value="startDatePickerValue" style="width: 100%; margin-top: 8px"
                :placeholder="$t('seller.accBonusProgram.creact.placeholderSelectDate')" :disabled-date="disablePastDates" />
              <p v-if="step1Errors.startDateTimestamp" class="field-error-text">{{ step1Errors.startDateTimestamp }}</p>
            </div>
            <div class="field" style="margin-bottom: 20px;margin-top: 0;"
              :class="{ 'field-error': !!step1Errors.endDateTimestamp }">
              <label>{{ $t('seller.accBonusProgram.creact.labelEndDate') }}<span class="label-required">*</span></label>
              <a-date-picker v-model:value="endDatePickerValue" style="width: 100%; margin-top: 8px"
                :placeholder="$t('seller.accBonusProgram.creact.placeholderSelectDate')" :disabled-date="disableEndDate" />
              <p v-if="step1Errors.endDateTimestamp" class="field-error-text">{{ step1Errors.endDateTimestamp }}</p>
            </div>
          </div>
        </div>

      </div>
      <div v-show="currentStep === 1" class="step-campaigns">

        <div class="campaign-notice">
          <span class="campaign-notice-icon">
            <svg class="icon" aria-hidden="true">
              <use xlink:href="#icon-a-warring-tianchong3"></use>
            </svg>
          </span>
          <div>
            <p>{{ $t('seller.accBonusProgram.creact.campaignNotice1') }}</p>
            <p>{{ $t('seller.accBonusProgram.creact.campaignNotice2') }}</p>
            <!-- <p>{{ $t('seller.accBonusProgram.creact.campaignNotice3') }}</p> -->
          </div>
        </div>

        <div class="panel">
          <div class="panel-button">
            <ButtonGroups :pagination="campaignPagination" :table-data="campaignList"
              @pageChange="onCampaignPageChange" />
              <div class="campaign-search-container">
                <span>
                  Campaign Name:
                </span>
                <a-input-search
              style="width: 256px"
            v-model:value="keywords"
            :placeholder="$t('seller.common.searchPlaceholder')"
            allow-clear
            @search="onSearch"
            @enter="onSearch"
          >
          </a-input-search>
              </div>
             
          </div>


          <artmisads-table class="campaign-table" :loading="campaignLoad" :columns="campaignColumns"
            :data-source="campaignList" row-key="campaignId" :row-selection="campaignRowSelection"
            v-model:pagination="campaignPagination" :change="onCampaignTableChange" :scroll="{ x: 1200 }">
            <template #bodyCell="{ column, record }">
              <template v-if="column.key === 'campaignName'">
                <a class="linkStyle" href="#" @click.prevent>{{ record.campaignName }}</a>
              </template>
              <template v-else-if="column.key === 'campaignStatus'">
                <Status :type="campaignStatusType(record.campaignStatus)"
                  :text="campaignStatusText(record.campaignStatus)" />
              </template>
              <template v-else-if="column.key === 'dates'">
                <div><span class="date-label">{{ $t('seller.accBonusProgram.creact.dateStart') }}</span> {{ formatCampaignDate(record.scheduleStartDateInEpochMills)
                  }}</div>
                <div><span class="date-label">{{ $t('seller.accBonusProgram.creact.dateEnd') }}</span> {{ formatCampaignDate(record.scheduleEndDateInEpochMills) }}
                </div>
              </template>
              <template v-else-if="column.key === 'totalBudget'">
                {{ campaignCurrencySymbol(record) }} {{ formatMoney(record.budget) }}
              </template>
              <template v-else-if="column.key === 'budgetRemaining'">
                <template v-if="record.budgetRemainingPercent != null">
                  {{ record.budgetRemainingPercent }}%
                </template>
                <template v-else>
                  {{ campaignCurrencySymbol(record) }} {{ formatMoney(record.budgetRemaining) }}
                </template>
              </template>
              <template v-else-if="column.key === 'commissionPercentage'">
                {{ record.accCommission ?? '-' }}%
              </template>
              <template v-else-if="column.key === 'productsCount'">
                <a class="linkStyle" href="#" @click.prevent>{{ record.productsCount ?? 0 }}</a>
              </template>
            </template>
          </artmisads-table>
        </div>
      </div>
      <div v-show="currentStep === 2" class="step-publishers">
        <div class="panel">
          <div class="panel-button">
            <ButtonGroups :pagination="publisherPagination" :table-data="publisherRows"
              @pageChange="onPublisherPageChange" />
          </div>

          <div class="publisher-filters">
            <div class="publisher-filter-item">
              <div class="publisher-filter-label">{{ $t('seller.publishersPage.filterPromotionMethod') }}</div>
              <div class="filter-content" ref="publisherFilterRef3">
                <a-select 
                :getPopupContainer="() => $refs.publisherFilterRef3"
                style="width: 256px" v-model:value="publisherFilter.promotionMethodId"
                  :placeholder="$t('seller.common.promotionMethod')" :show-search="false" :allowClear="true"
                  :options="promotionMethodsList" @change="handleChangePromotionMethodId" />
              </div>
            </div>
            <div class="publisher-filter-item">
              <div class="publisher-filter-label">{{ $t('seller.publishersPage.filterPromotionCategories') }}</div>
              <div class="filter-content" ref="publisherFilterRef2">
                <a-select 
                 :getPopupContainer="() => $refs.publisherFilterRef2"
                style="width: 256px" v-model:value="publisherFilter.promotionProductCategoryId"
                  :placeholder="$t('seller.common.promotionCategories')" :show-search="false" :allowClear="true"
                  :options="promotionProductCategoryList" :filter-option="filterCategoryListOption"
                  @change="handleChangePromotionProductCategoryId" />
              </div>
            </div>
            <div class="publisher-filter-item">
              <div class="publisher-filter-label">{{ $t('seller.cpcIndex.filterPublisherLabel') }}</div>
              <div class="filter-content" ref="publisherFilterRef">
                <a-select 
                  :getPopupContainer="() => $refs.publisherFilterRef"
                  style="width: 256px" v-model:value="publisherFilterPublisherId"
                  :placeholder="$t('seller.cpcCreate.placeholderPublisherSearch')" show-search :allow-clear="true"
                  :filter-option="false" :options="publisherFilterOptions" @search="onPublisherFilterSearch"
                  @change="onPublisherFilterChange" @dropdown-visible-change="onPublisherFilterDropdownVisible" />
              </div>
            </div>
          </div>

          <artmisads-table class="publisher-table" v-model:pagination="publisherPagination"
            :row-selection="publisherRowSelection" row-key="publisherId" :columns="publisherColumns"
            :data-source="publisherRows" :change="onPublisherTableChange" :loading="publisherListLoading"
            :scroll="{ x: 1180 }">
            <template #bodyCell="{ column, record }">
              <template v-if="column.key === 'publisher'">
                <div class="publisher-cell">
                  <LogoImage :max-width="'95%'"
                    :logo-url="record.publicImage || record.avatarUrl || record.publisherAvatarUrl"
                    :brand-name="record.creatorName || record.publisherName" :width="40" :height="40" :font-size="10"
                    :border-radius="4" />
                  <span class="publisher-name">{{ record.creatorName || record.publisherName }}</span>
                </div>
              </template>
              <template v-else-if="column.key === 'creatorName'">
                {{ record.creatorName || 'N/A' }}
              </template>
              <template v-else-if="column.key === 'bio'">
                <a-tooltip v-if="record.bio" placement="top" :mouse-enter-delay="0.5">
                  <template #title>
                    <span>{{ record.bio }}</span>
                  </template>
                  <div class="text-ellipsis-2">{{ record.bio }}</div>
                </a-tooltip>
                <span v-else>-</span>
              </template>
              <template v-else-if="column.key === 'promotionMethods'">
                {{ formatPromotionList(record.promotionMethods) }}
              </template>
              <template v-else-if="column.key === 'promotionProductCategories'">
                <a-tooltip placement="top" :mouse-enter-delay="0.5">
                  <template #title>
                    <span>{{ formatPromotionList(record.promotionCategories || record.promotionProductCategories)
                      }}</span>
                  </template>
                  <div class="text-ellipsis-2">
                    {{ formatPromotionList(record.promotionCategories || record.promotionProductCategories) }}
                  </div>
                </a-tooltip>
              </template>
            </template>
          </artmisads-table>
        </div>
      </div>
    </div>
    <div class="actions">
      <template v-if="currentStep === 0">
        <div class="actions-one">
          <artmisads-button type="default" @click="goCpc">{{ $t('seller.cpcCreate.btnCancel') }}</artmisads-button>
          <artmisads-button
            type="primary"
            :loading="isEditMode && editStepSaving"
            :disabled="isEditMode && editStepSaving"
            @click="nextStep"
          >{{ $t('seller.cpcCreate.btnSaveNext') }}</artmisads-button>
        </div>

      </template>
      <template v-else-if="currentStep === 1">
        <div class="actions-two">
          <span class="selected-campaigns-count">
            {{ $t('seller.accBonusProgram.creact.selectedCampaignsCount', { n: selectedCampaignCount }) }}
          </span>
          <div class="actions-right">
            <artmisads-button type="default" @click="prevStep">{{ $t('seller.cpcCreate.btnBack') }}</artmisads-button>
            <artmisads-button
              type="primary"
              :loading="isEditMode && editStepSaving"
              :disabled="(isEditMode && editStepSaving) || selectedCampaignCount === 0"
              @click="nextFromCampaignStep"
            >
              {{ $t('seller.cpcCreate.btnSaveNext') }}
            </artmisads-button>
          </div>
        </div>
      </template>
      <template v-else>
        <div class="actions-two">
          <span class="selected-publishers-count">{{ $t('seller.cpcCreate.selectedPublishersCount', {
            n:
              selectedPublisherCount
          }) }}</span>
          <div class="actions-right">
            <artmisads-button type="default" @click="prevStep">{{ $t('seller.cpcCreate.btnBack') }}</artmisads-button>
            <artmisads-button
              type="primary"
              :loading="isEditMode && editStepSaving"
              :disabled="(isEditMode && editStepSaving) || selectedPublisherCount === 0"
              @click="submitCampaign"
            >{{ $t('seller.cpcCreate.btnSubmit') }}</artmisads-button>
          </div>
        </div>

      </template>
    </div>
  </div>
</template>

<script setup>
import breadcrumbs from "../../breadcrumbs.vue"
import { computed, ref, reactive, watch, h, onMounted } from "vue"
import { message, Tooltip } from "ant-design-vue"
import { brandApi, accBonusProgramApi, publishersApi } from "@/server"
import { useI18n } from "vue-i18n"
import { useRouter } from "vue-router"
import moment from "moment"
import BrandSelect from "@/components/BrandSelect.vue"
import Icon from "@/components/Icon.vue"
import ButtonGroups from "../../Brands/components/buttonGroups.vue"
import Status from "@/components/Status.vue"
import LogoImage from "@/components/LogoImage.vue"
import { CURRENCY_MAPPER, CURRENCY_DATA_MAPPER, BILLING_TIME_TZ } from "@/contants/common"
import { useUserInfoStore } from "@/storeData"
import { useRoute } from "vue-router"
import noticeTool from "./noticeTool.vue"
const route = useRoute()
const marketplace = ref(route.query.marketplace || '')
const programId = ref(route.query.programId || '')
const isEditMode = computed(() => Boolean(programId.value))
const detailLoading = ref(false)
const editStepSaving = ref(false)
const { t } = useI18n()
const router = useRouter()
const keywords = ref('')
const onSearch = () => {
  campaignPagination.current = 1
  campaignPagination.page = 1
  fetchEligibleCampaigns()
}
const CPC_CREATE_STEP_TITLE_KEYS = [
  "seller.accBonusProgram.creact.stepSetupProgramInfo",
  "seller.accBonusProgram.creact.stepSelectAccCampaigns",
  "seller.accBonusProgram.creact.stepSelectPublishers",
]

const user = useUserInfoStore()
const countryCode = user?.userInfo?.countryCode || "US"
const timezone =
  BILLING_TIME_TZ[CURRENCY_MAPPER[countryCode]?.host || "amazon.com"] || "America/Los_Angeles"

const currentStep = ref(0)
const selectedCampaignIds = ref([])
const editCampaignCount = ref(0)
const editCampaignIds = ref([])
const campaignSelectionTouched = ref(false)
const MIN_TIERS = 2
const MAX_TIERS = 5
const keyword = ref('')
const campaignLoad = ref(false)
const campaignList = ref([])
const campaignPagination = reactive({
  total: 0,
  current: 1,
  size: 10,
  page: 1,
  pageSize: 10,
  showSizeChanger: true,
  pageSizeOptions: ['10', '20', '50', '100'],
})

const campaignColumns = computed(() => [
  { title: t("seller.accBonusProgram.creact.colCampaignName"), dataIndex: "campaignName", key: "campaignName", width: 200 },
  { title: t("seller.accBonusProgram.creact.colStatus"), dataIndex: "campaignStatus", key: "campaignStatus", width: 130 },
  { title: t("seller.accBonusProgram.creact.colDates"), dataIndex: "dates", key: "dates", width: 200 },
  { title: t("seller.accBonusProgram.creact.colBudget"), dataIndex: "totalBudget", key: "totalBudget", width: 100 },
  { title: t("seller.accBonusProgram.creact.colBudgetRemaining"), dataIndex: "budgetRemaining", key: "budgetRemaining", width: 150 },
  { title: t("seller.accBonusProgram.creact.colAccCommission"), dataIndex: "commissionPercentage", key: "commissionPercentage", width: 220 },
  { title: t("seller.accBonusProgram.creact.colProducts"), dataIndex: "productsCount", key: "productsCount", width: 90 },
])

const formatMoney = (val) => Number(val ?? 0).toFixed(2)
const campaignCurrencySymbol = (record) => CURRENCY_DATA_MAPPER[record.currencyCode] || "$"
const formatCampaignDate = (ts) => (ts ? moment(ts).tz(timezone).format("YYYY-MM-DD") : "-")

/** API selectable：true / "true" / 1 为可选 */
const parseSelectable = (value) => {
  if (value === true || value === 1) return true
  if (value === false || value === 0 || value == null) return false
  if (typeof value === "string") {
    const normalized = value.trim().toLowerCase()
    return normalized === "true" || normalized === "1"
  }
  return false
}

const normalizeCampaignId = (id) => String(id ?? "").trim()
const getCampaignRowId = (record) => record?.campaignId ?? record?.id

const getCampaignItemId = (item) =>
  typeof item === "object" ? normalizeCampaignId(item.campaignId ?? item.id) : normalizeCampaignId(item)

const isCampaignItemSelected = (item) => {
  if (typeof item !== "object") return true
  return parseSelectable(item.selected ?? item.select)
}

const normalizeCampaignRow = (row) => ({
  ...row,
  selectable: parseSelectable(row.selectable),
  selected: parseSelectable(row.selected),
})

const isCampaignSelectable = (record) => parseSelectable(record?.selectable)

/** 表格勾选：由 selectedCampaignIds 中 selected === true 的项决定 */
const campaignSelectedRowKeys = computed(() =>
  selectedCampaignIds.value
    .filter(isCampaignItemSelected)
    .map(getCampaignItemId)
    .filter(Boolean),
)

const selectedCampaignCount = computed(() => {
  const fromSelection = selectedCampaignIds.value.filter(isCampaignItemSelected).length
  if (isEditMode.value && !campaignSelectionTouched.value) {
    return editCampaignCount.value ?? fromSelection
  }
  return fromSelection
})

const syncCampaignSelectionAfterLoad = () => {
  for (const row of campaignList.value) {
    const id = normalizeCampaignId(getCampaignRowId(row))
    if (!id) continue
    const item = selectedCampaignIds.value.find((x) => getCampaignItemId(x) === id)
    if (parseSelectable(row.selected)) {
      if (item && typeof item === "object") {
        item.selected = true
      } else {
        selectedCampaignIds.value.push({ campaignId: id, selected: true })
      }
    } else if (item && isCampaignItemSelected(item)) {
      row.selected = true
    }
  }
}

const onCampaignSelectChange = (keys) => {
  campaignSelectionTouched.value = true
  const normalizedKeys = new Set((keys || []).map((id) => normalizeCampaignId(id)))
  const pageIds = campaignList.value.map((r) => normalizeCampaignId(getCampaignRowId(r)))

  campaignList.value.forEach((row) => {
    const id = normalizeCampaignId(getCampaignRowId(row))
    row.selected = normalizedKeys.has(id)
    let item = selectedCampaignIds.value.find((x) => getCampaignItemId(x) === id)
    if (item && typeof item === "object") {
      item.selected = normalizedKeys.has(id)
    } else if (normalizedKeys.has(id)) {
      selectedCampaignIds.value.push({ campaignId: id, selected: true })
    }
  })

  for (const id of pageIds) {
    if (!normalizedKeys.has(id)) {
      const item = selectedCampaignIds.value.find((x) => getCampaignItemId(x) === id)
      if (item && typeof item === "object") {
        item.selected = false
      }
    }
  }
}

const campaignRowSelection = computed(() => ({
  selectedRowKeys: campaignSelectedRowKeys.value,
  preserveSelectedRowKeys: true,
  onChange: onCampaignSelectChange,
  getCheckboxProps: (record) => ({
    disabled: !isCampaignSelectable(record),
  }),
  renderCell: (checked, record, _index, originNode) => {
    if (isCampaignSelectable(record)) return originNode
    return h(
      Tooltip,
      {
        title: t("seller.accBonusProgram.campaignAlreadyInOtherProgram"),
        placement: "top",
        getPopupContainer: () => document.body,
      },
      {
        default: () =>
          h("span", { class: "acc-campaign-locked-select-tooltip-wrap" }, [originNode]),
      },
    )
  },
}))

const campaignStatusText = (status) => {
  const map = {
    DELIVERING: t("seller.sellerAccount.campaignStatusDelivering"),
    ENDED: t("seller.sellerAccount.campaignStatusEnded"),
    EXPIRED: t("seller.sellerAccount.campaignStatusExpired"),
    OUTOFBUDGET: t("seller.sellerAccount.campaignStatusOutOfBudget"),
    CREATED: t("seller.sellerAccount.campaignStatusCreated"),
    DELETED: t("seller.sellerAccount.campaignStatusDeleted"),
  }
  return map[status] || status
}

const campaignStatusType = (status) => {
  if (status === "ACTIVE" || status === "SCHEDULED" || status === "ENDED") return "active"
  if (status === "EXPIRED") return "finished"
  if (status === "OUT_OF_BUDGET") return "pending"
  if (status === "ENDED_GRACE_PERIOD") return "inactive"
  if (status === "DELETED") return "not_authorized"
  if (status === "DELIVERING" || status === "CREATED") return "delivering"
  return "inactive"
}

const fetchEligibleCampaigns = async () => {
  campaignLoad.value = true
  try {
    const res = await accBonusProgramApi.getProgramCampaignList({
      brandId: form.brandId,
      programId: programId.value || undefined,
      page: campaignPagination.current,
      size: campaignPagination.size,
      marketplace: marketplace.value,
      keyword: keywords.value,
    })
    if (res?.success && res?.data) {
      campaignList.value = (res.data.data ?? []).map(normalizeCampaignRow)
      campaignPagination.total = res.data.total ?? campaignList.value.length
      syncCampaignSelectionAfterLoad()
    }
  } catch {

  } finally {
    campaignLoad.value = false
  }
}

const onCampaignPageChange = (page) => {
  campaignPagination.current = page
  campaignPagination.page = page
  fetchEligibleCampaigns()
}

const onCampaignTableChange = ({ current, pageSize }) => {
  campaignPagination.current = current
  campaignPagination.page = current
  campaignPagination.size = pageSize
  campaignPagination.pageSize = pageSize
  fetchEligibleCampaigns()
}

const publisherPagination = reactive({
  total: 0,
  current: 1,
  pageSize: 10,
  size: 10,
  showSizeChanger: true,
  pageSizeOptions: ["10", "20", "30", "40", "50"],
})
const publisherRows = ref([])
const publisherListLoading = ref(false)
const publisherFilter = reactive({
  promotionMethodId: "",
  promotionProductCategoryId: "",
})
const publisherFilterPublisherId = ref("")
const promotionMethodsList = ref([])
const promotionProductCategoryList = ref([])
const publisherFilterOptions = ref([])
const allSelectedPublisherIds = ref(new Set())
const editPublisherCount = ref(0)
const editPublisherIds = ref([])
const publisherSelectionTouched = ref(false)
const normalizePublisherId = (id) => String(id ?? "").trim()
const getPublisherRowId = (record) => record?.publisherId ?? record?.id

const parseSelected = (value) => parseSelectable(value)

const normalizePublisherRow = (row) => {
  const id = normalizePublisherId(row?.publisherId ?? row?.id)
  return {
    ...row,
    id,
    publisherId: id,
    selected: parseSelected(row?.selected),
    selectable: row?.selectable != null ? parseSelectable(row.selectable) : true,
  }
}

const isPublisherSelectable = (record) => parseSelectable(record?.selectable)

/** 当前页勾选：由 publisherRows 中 selected === true 决定 */
const publisherSelectedRowKeys = computed(() =>
  publisherRows.value
    .filter((row) => row.selected === true)
    .map((row) => normalizePublisherId(getPublisherRowId(row)))
    .filter(Boolean),
)

const publisherColumns = computed(() => [
  { title: t("seller.cpcCreate.colPublisher"), key: "publisher", dataIndex: "publisher", width: 220 },
  { title: t("seller.accBonusProgram.creact.colCreatorName"), key: "creatorName", dataIndex: "creatorName", width: 220 },
  { title: t("seller.accBonusProgram.creact.colBio"), key: "bio", dataIndex: "bio", width: 280 },
  {
    title: t("seller.cpcCreate.colPromotionMethod"),
    key: "promotionMethods",
    dataIndex: "promotionMethods",
    width: 220,
  },
  {
    title: t("seller.cpcCreate.colPromotionCategories"),
    key: "promotionProductCategories",
    dataIndex: "promotionProductCategories",
    width: 280,
  },
])

const filterCategoryListOption = (input, option) =>
  String(option?.label ?? "")
    .toLowerCase()
    .includes(String(input ?? "").toLowerCase())

const formatPromotionList = (list) => {
  if (!list?.length) return "-"
  return list
    .map((item) => (typeof item === "string" ? item : item?.name ?? item))
    .filter(Boolean)
    .join(", ")
}

const syncPublisherSelectionAfterLoad = () => {
  for (const row of publisherRows.value) {
    const id = normalizePublisherId(getPublisherRowId(row))
    if (!id) continue
    if (row.selected) {
      allSelectedPublisherIds.value.add(id)
    } else if (allSelectedPublisherIds.value.has(id)) {
      row.selected = true
    }
  }
}

const onPublisherSelectChange = (keys) => {
  publisherSelectionTouched.value = true
  const normalizedKeys = new Set((keys || []).map((id) => normalizePublisherId(id)))
  const pageIds = publisherRows.value.map((r) => normalizePublisherId(getPublisherRowId(r)))

  publisherRows.value.forEach((row) => {
    const id = normalizePublisherId(getPublisherRowId(row))
    row.selected = normalizedKeys.has(id)
  })

  for (const id of pageIds) {
    allSelectedPublisherIds.value.delete(id)
  }
  for (const id of normalizedKeys) {
    allSelectedPublisherIds.value.add(id)
  }
}

const publisherRowSelection = computed(() => ({
  selectedRowKeys: publisherSelectedRowKeys.value,
  preserveSelectedRowKeys: true,
  onChange: onPublisherSelectChange,
  getCheckboxProps: (record) => ({
    disabled: !isPublisherSelectable(record),
  }),
}))

const selectedPublisherCount = computed(() => {
  const fromSelection = allSelectedPublisherIds.value.size
  if (isEditMode.value && !publisherSelectionTouched.value) {
    return editPublisherCount.value ?? fromSelection
  }
  return fromSelection
})

const getPromotionMethodsList = async () => {
  const res = await publishersApi.getPromotionMethodsList()
  const { success, error, data } = res
  if (success) {
    promotionMethodsList.value = data.map((item) => ({
      value: item.id,
      label: item.name,
    }))
    promotionMethodsList.value.unshift({
      value: "",
      label: t("seller.common.all"),
    })
  } else if (error) {
    message.error(error)
  }
}

const getPromotionProductCategoryList = async () => {
  const res = await publishersApi.getPromotionProductCategoryList()
  const { success, error, data } = res
  if (success) {
    promotionProductCategoryList.value = data.map((item) => ({
      value: item.id,
      label: item.name,
    }))
    promotionProductCategoryList.value.unshift({
      value: "",
      label: t("seller.common.all"),
    })
  } else if (error) {
    message.error(error)
  }
}

const handleChangePromotionMethodId = (value) => {
  publisherFilter.promotionMethodId = value ?? ""
  publisherFilterPublisherId.value = ""
  keyword.value = ""
  publisherPagination.current = 1
  
  loadPublisherList()
}

const handleChangePromotionProductCategoryId = (value) => {
  publisherFilter.promotionProductCategoryId = value ?? ""
  publisherFilterPublisherId.value = ""
  keyword.value = ""
  publisherPagination.current = 1
  
  loadPublisherList()
}

const buildPublisherFilterOptions = (rows) => {
  const seen = new Set()
  const opts = [{ value: "", label: t("seller.common.all") }]
  for (const row of rows || []) {
    const id = normalizePublisherId(getPublisherRowId(row))
    if (!id || seen.has(id)) continue
    seen.add(id)
    opts.push({
      value: id,
      label: row.creatorName || row.publisherName || id,
    })
  }
  publisherFilterOptions.value = opts
}

let publisherFilterSearchTimer = null

const loadPublisherFilterOptions = async (searchText = "") => {
  try {
    const res = await accBonusProgramApi.getProgramPublisherList({
      page: 1,
      size: 50,
      keyword: searchText || undefined,
      marketplace: marketplace.value,
    })
    const { success, data } = res
    if (success) {
      buildPublisherFilterOptions((data?.data ?? []).map(normalizePublisherRow))
    } else {
      publisherFilterOptions.value = [{ value: "", label: t("seller.common.all") }]
    }
  } catch {
    publisherFilterOptions.value = [{ value: "", label: t("seller.common.all") }]
  }
}

const onPublisherFilterSearch = (searchText) => {
  if (publisherFilterSearchTimer) clearTimeout(publisherFilterSearchTimer)
  publisherFilterSearchTimer = setTimeout(() => {
    loadPublisherFilterOptions(searchText)
  }, 300)
}

const onPublisherFilterDropdownVisible = (open) => {
  if (open && publisherFilterOptions.value.length <= 1) {
    loadPublisherFilterOptions("")
  }
}

/** 与 associateCentral/publishers/index.vue getList 同一接口与筛选参数 */
const loadPublisherList = async () => {
  publisherListLoading.value = true
  try {
    const res = await accBonusProgramApi.getProgramPublisherList({
      programId: programId.value || undefined,
      brandId: form.brandId,
      page: publisherPagination.current,
      size: publisherPagination.size,
      keyword: keyword.value,
      promotionMethodIds: publisherFilter.promotionMethodId ? publisherFilter.promotionMethodId : undefined,
      promotionCategoryIds: publisherFilter.promotionProductCategoryId ? publisherFilter.promotionProductCategoryId : undefined,
      marketplace: marketplace.value,
    })
    const { success, error, data } = res
    if (success) {
      publisherRows.value = (data?.data ?? []).map(normalizePublisherRow)
      publisherPagination.total = data?.total ?? 0
      syncPublisherSelectionAfterLoad()
    } else {
      message.error(error)
      publisherRows.value = []
      publisherPagination.total = 0
    }
  } catch {
    message.error(t("seller.msg.getDataFailed"))
    publisherRows.value = []
    publisherPagination.total = 0
  } finally {
    publisherListLoading.value = false
  }
}

const onPublisherPageChange = (page) => {
  publisherPagination.current = page
  loadPublisherList()
}

const onPublisherTableChange = ({ current, pageSize }) => {
  publisherPagination.current = current
  publisherPagination.pageSize = pageSize
  publisherPagination.size = pageSize
  loadPublisherList()
}

const onPublisherFilterChange = (value) => {
  publisherFilterPublisherId.value = value ?? ""
  if (!value) {
    keyword.value = ""
  } else {
    const opt = publisherFilterOptions.value.find((o) => o.value === value)
    keyword.value = opt?.label ?? ""
  }
  publisherPagination.current = 1
  loadPublisherList()
}

let publisherListsLoaded = false
const ensurePublisherStepData = async () => {
  if (!publisherListsLoaded) {
    publisherListsLoaded = true
    await Promise.all([getPromotionMethodsList(), getPromotionProductCategoryList()])
    await loadPublisherFilterOptions()
  }
  await loadPublisherList()
}

watch(currentStep, (step) => {
  if (step === 2) {
    ensurePublisherStepData()
  }
})

const createTier = (level) => ({
  tierLevel: level,
  targetSales: null,
  bonusRate: null,
})

const createDefaultTiers = () => [createTier(1), createTier(2)]

const ensureMinTiers = (tiers) => {
  const result = [...tiers]
  while (result.length < MIN_TIERS) {
    result.push(createTier(result.length + 1))
  }
  return result
}

const tierTargetSalesErrors = reactive({})

const breadcrumbsData = computed(() => ({
  title: t("seller.accBonusProgram.pageTitle"),
  color: "#26AADC",
  des: t("seller.cpcCreate.pageDes"),
  hasTitleIcon: false,
  links: [
    { name: t("seller.common.home"), path: "/seller/dashboard" },
    {
      name: t("seller.menu.creatorConnections"),
      path: "/seller/creatorConnections/accBonusProgram",
    },
    {
      name: t("seller.accBonusProgram.pageTitle"),
      path: "/seller/creatorConnections/accCreact",
    },
  ],
}))

const form = reactive({
  title: "",
  brandId: "",
  brandName: "",
  // fixed/tier
  bonusRuleType: "fixed",
  fixedCpsRate: null,
  tiers: createDefaultTiers(),
  startDateTimestamp: null,
  endDateTimestamp: null,
})

const step1Errors = reactive({
  title: "",
  brandId: "",
  bonusRule: "",
  fixedCpsRate: "",
  tiers: "",
  startDateTimestamp: "",
  endDateTimestamp: "",
})

const clearTierTargetSalesErrors = () => {
  Object.keys(tierTargetSalesErrors).forEach((key) => {
    delete tierTargetSalesErrors[key]
  })
}

const clearStep1Errors = () => {
  step1Errors.title = ""
  step1Errors.brandId = ""
  step1Errors.bonusRule = ""
  step1Errors.fixedCpsRate = ""
  step1Errors.tiers = ""
  step1Errors.startDateTimestamp = ""
  step1Errors.endDateTimestamp = ""
  clearTierTargetSalesErrors()
}

const validateTierTargetSalesAt = (index, { showError = true } = {}) => {
  if (showError) delete tierTargetSalesErrors[index]

  if (index <= 0) return true

  const tier = form.tiers[index]
  const prev = form.tiers[index - 1]
  if (!tier || !prev) return true

  const currVal = tier.targetSales
  const prevVal = prev.targetSales
  if (currVal == null || prevVal == null) return true

  if (Number(currVal) <= Number(prevVal)) {
    const msg = t("seller.accBonusProgram.tierTargetMustExceedPrevious")
    if (showError) tierTargetSalesErrors[index] = msg
    return false
  }
  return true
}

const validateAllTierTargetSales = ({ showError = false } = {}) => {
  if (showError) clearTierTargetSalesErrors()
  let ok = true
  for (let i = 1; i < form.tiers.length; i++) {
    if (!validateTierTargetSalesAt(i, { showError })) ok = false
  }
  return ok
}

const onTierTargetSalesChange = (index) => {
  validateTierTargetSalesAt(index, { showError: true })
  for (let i = index + 1; i < form.tiers.length; i++) {
    validateTierTargetSalesAt(i, { showError: true })
  }
  step1Errors.tiers = ""
}

const startDatePickerValue = computed({
  get: () => (form.startDateTimestamp ? moment(form.startDateTimestamp) : null),
  set: (val) => {
    form.startDateTimestamp = val ? moment(val).startOf("day").valueOf() : null
  },
})

const endDatePickerValue = computed({
  get: () => (form.endDateTimestamp ? moment(form.endDateTimestamp) : null),
  set: (val) => {
    form.endDateTimestamp = val ? moment(val).startOf("day").valueOf() : null
  },
})

watch(
  () => form.brandId,
  async (brandId) => {
    if (!brandId) {
      form.brandName = ""
      return
    }
    try {
      const res = await brandApi.getBrandDetail({ brandId })
      if (res?.success && res?.data) {
        form.brandName = res.data.amazonBrandName || res.data.brandName || ""
      }
    } catch {
      form.brandName = ""
    }
  }
)

const pickerDayToMomentStart = (value) => {
  if (!value) return null
  if (moment.isMoment(value)) return value.clone().startOf("day")
  return moment(value).startOf("day")
}

const disablePastDates = (current) => {
  const cur = pickerDayToMomentStart(current)
  if (!cur?.isValid()) return false
  return cur.isBefore(moment().startOf("day"), "day")
}

const isLastDayOfMonth = (day) => day.date() === day.clone().endOf("month").date()

const disableEndDate = (current) => {
  const cur = pickerDayToMomentStart(current)
  if (!cur?.isValid()) return false
  // 仅允许选择每月最后一天（含当月最后一天）
  if (!isLastDayOfMonth(cur)) return true
  if (cur.isBefore(moment().startOf("day"), "day")) return true
  if (form.startDateTimestamp) {
    const startDay = moment(form.startDateTimestamp).startOf("day")
    if (startDay && cur.isBefore(startDay, "day")) return true
  }
  return false
}

const onBonusRuleTypeChange = () => {
  step1Errors.bonusRule = ""
  step1Errors.fixedCpsRate = ""
  step1Errors.tiers = ""
  if (form.bonusRuleType === "fixed") {
    form.fixedCpsRate = form.fixedCpsRate ?? null
  } else if (form.bonusRuleType === "tier" && form.tiers.length < MIN_TIERS) {
    form.tiers = createDefaultTiers()
  }
  clearTierTargetSalesErrors()
}

const addTier = () => {
  if (form.tiers.length >= MAX_TIERS) return
  form.tiers.push(createTier(form.tiers.length + 1))
}

const removeTier = () => {
  if (form.tiers.length <= MIN_TIERS) return
  form.tiers.pop()
  form.tiers.forEach((tier, index) => {
    tier.tierLevel = index + 1
  })
  clearTierTargetSalesErrors()
}

const validateStep1 = () => {
  clearStep1Errors()
  let valid = true

  if (!form.title?.trim()) {
    step1Errors.title = t("seller.accBonusProgram.creact.errProgramTitleRequired")
    valid = false
  }
  if (!form.brandId) {
    step1Errors.brandId = t("seller.accBonusProgram.creact.errBrandRequired")
    valid = false
  }

  if (form.bonusRuleType === "fixed") {
    if (form.fixedCpsRate == null || form.fixedCpsRate <= 0) {
      step1Errors.fixedCpsRate = t("seller.accBonusProgram.creact.errBonusRateRequired")
      valid = false
    }
  } else if (form.bonusRuleType === "tier") {
    const invalidTier = form.tiers.some(
      (tier) =>
        tier.targetSales == null ||
        tier.targetSales < 0 ||
        tier.bonusRate == null ||
        tier.bonusRate <= 0
    )
    if (invalidTier || !form.tiers.length) {
      step1Errors.tiers = t("seller.accBonusProgram.creact.errTierCompleteAll")
      valid = false
    }
  } else {
    step1Errors.bonusRule = t("seller.accBonusProgram.creact.errBonusRuleRequired")
    valid = false
  }

  if (!form.startDateTimestamp) {
    step1Errors.startDateTimestamp = t("seller.accBonusProgram.creact.errStartDateRequired")
    valid = false
  }
  if (!form.endDateTimestamp) {
    step1Errors.endDateTimestamp = t("seller.accBonusProgram.creact.errEndDateRequired")
    valid = false
  }
  if (form.endDateTimestamp) {
    const end = moment(form.endDateTimestamp).startOf("day")
    if (!isLastDayOfMonth(end)) {
      step1Errors.endDateTimestamp = t("seller.accBonusProgram.creact.errEndDateLastDayOfMonth")
      valid = false
    }
  }
  if (form.startDateTimestamp && form.endDateTimestamp) {
    const start = moment(form.startDateTimestamp).startOf("day")
    const end = moment(form.endDateTimestamp).startOf("day")
    if (end.isBefore(start, "day")) {
      step1Errors.endDateTimestamp = t("seller.accBonusProgram.creact.errEndDateOnOrAfterStart")
      valid = false
    }
  }

  return valid
}

/** Step1 payload aligned with API field names */
const getStep1Payload = () => ({
  title: form.title.trim(),
  brandId: form.brandId,
  brandName: form.brandName,
  bonusRuleType: form.bonusRuleType,
  fixedCpsRate: form.bonusRuleType === "fixed" ? form.fixedCpsRate/100 : undefined,
  tierRates:
    form.bonusRuleType === "tier"
      ? form.tiers.map(({ tierLevel, targetSales, bonusRate }) => ({
          targetSales,
          bonusRate: bonusRate != null ? bonusRate / 100 : null,
        }))
      : undefined,
  startDateTimestamp: form.startDateTimestamp,
  endDateTimestamp: form.endDateTimestamp,
})

const goCpc = () => router.push("/seller/creatorConnections/accBonusProgram")

const nextStep = async () => {
  if (currentStep.value === 0 && !validateStep1()) return
  if (isEditMode.value) {
    if (editStepSaving.value) return
    editStepSaving.value = true
    try {
      const res = await accBonusProgramApi.editProgramStep1({
        programId: programId.value,
        marketplace: marketplace.value,
        ...getStep1Payload(),
      })
      if (!res?.success) {
        message.error(res?.error || t("seller.accBonusProgram.editFailed"))
        return
      }
      message.success(t("seller.accBonusProgram.editSuccess"))
    } finally {
      editStepSaving.value = false
    }
  }
  if (currentStep.value === 0) {
    campaignPagination.current = 1
    campaignPagination.page = 1
    fetchEligibleCampaigns()
  }
  if (currentStep.value < 2) currentStep.value += 1
}

const prevStep = () => {
  if (currentStep.value <= 0) return
  const targetStep = currentStep.value - 1
  currentStep.value = targetStep
  if (targetStep === 1) {
    fetchEligibleCampaigns()
  } else if (targetStep === 2) {
    loadPublisherList()
  }
}

const getSelectedCampaignIdsFromUi = () =>
  selectedCampaignIds.value
    .filter(isCampaignItemSelected)
    .map(getCampaignItemId)
    .filter(Boolean)

/** 编辑态：以详情 campaignIds 为底，叠加当前页的勾选/取消 */
const getMergedCampaignIds = () => {
  if (!isEditMode.value) return getSelectedCampaignIdsFromUi()

  const merged = new Set(
    editCampaignIds.value.map((id) => normalizeCampaignId(id)).filter(Boolean),
  )
  for (const item of selectedCampaignIds.value) {
    const id = getCampaignItemId(item)
    if (!id) continue
    if (isCampaignItemSelected(item)) {
      merged.add(id)
    } else if (typeof item === "object" && item.selected === false) {
      merged.delete(id)
    }
  }
  return [...merged]
}

const getStep2Payload = () => ({
  campaignIds: getMergedCampaignIds(),
})

const nextFromCampaignStep = async () => {
  if (!selectedCampaignCount.value) return
  if (isEditMode.value) {
    if (editStepSaving.value) return
    editStepSaving.value = true
    try {
      const res = await accBonusProgramApi.editProgramStep2({
        programId: programId.value,
        marketplace: marketplace.value,
        ...getStep2Payload(),
      })
      if (!res?.success) {
        message.error(res?.error || t("seller.accBonusProgram.editFailed"))
        currentStep.value += 1
        return
      }
      message.success(t("seller.accBonusProgram.editSuccess"))
    } finally {
      editStepSaving.value = false
    }
  }
  currentStep.value += 1

}

/** 编辑态：以详情 publisherIds 为底，叠加当前页的勾选/取消 */
const getMergedPublisherIds = () => {
  if (!isEditMode.value) {
    return [...allSelectedPublisherIds.value]
      .map((id) => normalizePublisherId(id))
      .filter(Boolean)
  }

  const merged = new Set(
    editPublisherIds.value.map((id) => normalizePublisherId(id)).filter(Boolean),
  )

  for (const id of allSelectedPublisherIds.value) {
    merged.add(normalizePublisherId(id))
  }

  const pageIds = publisherRows.value.map((r) => normalizePublisherId(getPublisherRowId(r)))
  for (const id of pageIds) {
    if (!allSelectedPublisherIds.value.has(id)) {
      merged.delete(id)
    }
  }

  return [...merged]
}

const getStep3Payload = () => ({
  publisherIds: getMergedPublisherIds(),
})

const toEpochMs = (val) => {
  if (val == null || val === "") return null
  if (typeof val === "number") return val
  const m = moment(val)
  return m.isValid() ? m.valueOf() : null
}

const applyProgramDetail = (res) => {
  const d = res?.data ?? res
  if (!d) return

  form.title = d.title ?? ""
  form.brandId = d.brandId ?? ""
  form.brandName = d.brandName ?? ""

  const ruleType = String(d.bonusRuleType || "").toLowerCase()
  form.bonusRuleType = ruleType === "tier" ? "tier" : "fixed"
  form.fixedCpsRate = d.cpsRate*100 ?? null

  if (Array.isArray(d.tierRates) && d.tierRates.length) {
    form.tiers = ensureMinTiers(
      d.tierRates.map((tier, index) => ({
        tierLevel: tier.tierLevel ?? index + 1,
        targetSales: tier.targetSales ?? null,
        bonusRate: tier.bonusRate*100 ?? null,
      })),
    )
  } else if (form.bonusRuleType === "tier") {
    form.tiers = createDefaultTiers()
  }
  clearTierTargetSalesErrors()

  form.startDateTimestamp = toEpochMs(
    d.startDateTimestamp ?? d.startDateInEpochMills ?? d.startDate,
  )
  form.endDateTimestamp = toEpochMs(
    d.endDateTimestamp ?? d.endDateInEpochMills ?? d.endDate,
  )

  if (Array.isArray(d.campaigns) && d.campaigns.length) {
    selectedCampaignIds.value = d.campaigns.map((c) => ({
      campaignId: normalizeCampaignId(c.campaignId ?? c.id),
      selected: parseSelectable(c.selected ?? c.select ?? true),
    }))
  } else {
    const campaignIds = d.campaignIds ?? []
    selectedCampaignIds.value = campaignIds.map((id) => ({
      campaignId: normalizeCampaignId(id),
      selected: true,
    }))
  }
  campaignSelectionTouched.value = false
  editCampaignIds.value = (
    d.campaignIds ??
    d.campaigns?.map((c) => c.campaignId ?? c.id) ??
    selectedCampaignIds.value.filter(isCampaignItemSelected).map(getCampaignItemId)
  )
    .map((id) => normalizeCampaignId(id))
    .filter(Boolean)
  editCampaignCount.value =
    Number(d.campaignCount ?? editCampaignIds.value.length) || 0

  const publisherIds =
    d.publisherIds ??
    d.publishers?.map((p) => p.publisherId ?? p.id) ??
    []
  publisherSelectionTouched.value = false
  editPublisherIds.value = publisherIds
    .map((id) => normalizePublisherId(id))
    .filter(Boolean)
  editPublisherCount.value = Number(d.publisherCount ?? editPublisherIds.value.length) || 0
  allSelectedPublisherIds.value = new Set(editPublisherIds.value)
}

const fetchProgramDetail = async () => {
  if (!programId.value) return
  detailLoading.value = true
  try {
    const res = await accBonusProgramApi.getProgramDetail({
      programId: programId.value,

    })
    if (res?.success && res?.data) {
      applyProgramDetail(res)
    } else {
      message.error(res?.error || t("seller.msg.getDataFailed"))
    }
  } catch {
    message.error(t("seller.msg.getDataFailed"))
  } finally {
    detailLoading.value = false
  }
}

const submitCampaign = async () => {
  if (!selectedPublisherCount.value) return
  const base = { programId: programId.value, marketplace: marketplace.value }

  try {
    if (isEditMode.value) {
      if (editStepSaving.value) return
      editStepSaving.value = true
      try {
        const res3 = await accBonusProgramApi.editProgramStep3({
          programId: programId.value,
          marketplace: marketplace.value,
          ...getStep3Payload(),
        })
        if (res3?.success) {
          message.success(t("seller.accBonusProgram.editSuccess"))
          router.push("/seller/creatorConnections/accBonusProgram")
        } else {
          message.error(res3?.error || t("seller.accBonusProgram.editFailed"))
        }
      } finally {
        editStepSaving.value = false
      }
      return
    }

    const res = await accBonusProgramApi.createProgram({
      ...getStep1Payload(),
      ...getStep2Payload(),
      ...getStep3Payload(),
      marketplace: marketplace.value,
    })
    if (res?.success) {
      message.success(t("seller.accBonusProgram.createSuccess"))
      router.push("/seller/creatorConnections/accBonusProgram")
    } else if (res?.error) {
      message.error(res.error)
    }
  } catch {
    message.error(
      t(isEditMode.value ? "seller.accBonusProgram.editFailed" : "seller.accBonusProgram.createFailed"),
    )
  }
}

onMounted(() => {
  if (programId.value) {
    fetchProgramDetail()
  }
  // loadPublisherList()
  // ensurePublisherStepData()
  // fetchEligibleCampaigns()
})
</script>

<style scoped lang="less">
:deep(.footer) {
  display: none !important;
}

.date-label {
  font-family: Sora;
  font-weight: 400;
  font-style: Regular;
  font-size: 13px;
  leading-trim: NONE;
  line-height: 15px;
  letter-spacing: 0.3px;
  color: rgba(15, 6, 41, 0.5);
  min-width: 40px;
  display: inline-block;
}

.form-title {
  font-family: Sora;
  font-weight: 600;
  font-size: 20px;
  leading-trim: NONE;
  line-height: 28px;
  letter-spacing: 0.5px;
  color: rgba(15, 6, 41, 1);
  padding: 16px 0;
  border-bottom: 1px solid rgba(232, 229, 237, 1);
}

.form-content {
  padding-top: 16px;
}

.cpc-create {
  padding: 0 24px;
  padding-top: 0;
}

.breadcrumb-line {
  color: #6b7280;
  font-size: 14px;
  margin-bottom: 8px;
}

.crumb {
  cursor: pointer;
}

.crumb.current {
  color: #111827;
  cursor: default;
}

.divider {
  margin: 0 6px;
}

.title {
  margin: 0 0 12px;
  color: #374151;
  font-size: 28px;
  line-height: 1.2;
  font-weight: 700;
}

.panel {
  background: #fff;
  border-radius: 8px 8px 0 0;
  padding: 0 24px;
  box-shadow: var(--section-box-shadow-6);
}

.panel-button {
  padding: 16px 0;
  display: flex;
  align-items: center;
  justify-content: space-between;
}
.campaign-search-container{
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;
}
.steps {
  margin-bottom: 18px;
  --cpc-step-active: rgba(131, 92, 242, 1);
  --cpc-step-active-soft: rgba(105, 74, 194, 0.22);
  --cpc-step-wait-border: #e5e7eb;
  --cpc-step-wait-text: #9ca3af;
  --cpc-step-finish: rgba(105, 74, 194, 0.85);
  /* 步骤间横杠：浅灰细线（与圆点、标题视觉对齐） */
  --cpc-step-line: #e5e7eb;

  /* steps 与 .steps 在同一根节点，不能用 .steps .ant-steps 后代选择器 */
  &.ant-steps {
    overflow: visible;
  }

  // :deep(.ant-steps-item) {
  //   overflow: visible;
  // }

  :deep(.ant-steps-item-container) {
    outline: none;
    height: 50px;
    display: flex;
    align-items: center;
    margin-left: 5px;
  }

  /* 自定义 #icon 只有数字时，避免图标区宽度被压窄成竖条，保持正圆 */
  :deep(.ant-steps-item-icon) {
    flex-shrink: 0;
    box-sizing: border-box;
    width: 32px !important;
    height: 32px !important;
    min-width: 32px !important;
    min-height: 32px !important;
    padding: 0 !important;
    border-radius: 50% !important;
    display: inline-flex !important;
    align-items: center;
    justify-content: center;
    line-height: 1 !important;
  }

  :deep(.ant-steps-item-icon .cpc-step-index) {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 100%;
    height: 100%;
    font-size: 16px;
    line-height: 1;
  }

  /* 激活：紫底白字 + 外圈光晕 */
  :deep(.ant-steps-item-process .ant-steps-item-icon) {
    background: var(--cpc-step-active) !important;
    border-color: var(--cpc-step-active) !important;
    color: #fff !important;
    box-shadow: 0 0 0 5px var(--cpc-step-active-soft);
  }

  :deep(.ant-steps-item-process .ant-steps-item-icon .ant-steps-icon) {
    color: #fff !important;
  }

  :deep(.ant-steps-item-process .ant-steps-item-icon span) {
    color: #fff !important;
  }

  :deep(.ant-steps-item-process.ant-steps-item-active .ant-steps-item-icon) {
    box-shadow: 0 0 0 5px var(--cpc-step-active-soft);
  }

  /* 未进行：浅灰描边 */
  :deep(.ant-steps-item-wait .ant-steps-item-icon) {
    background: #fff !important;
    border-color: var(--cpc-step-wait-border) !important;
    color: var(--cpc-step-wait-text) !important;
  }

  :deep(.ant-steps-item-wait .ant-steps-item-icon .ant-steps-icon) {
    color: var(--cpc-step-wait-text) !important;
  }

  /* 已完成 */
  :deep(.ant-steps-item-finish .ant-steps-item-icon) {
    background: #fff !important;
    border-color: var(--cpc-step-finish) !important;
    color: var(--cpc-step-finish) !important;
  }

  :deep(.ant-steps-item-finish .ant-steps-item-icon .ant-steps-icon) {
    color: var(--cpc-step-finish) !important;
  }



  :deep(.ant-steps-item-finish > .ant-steps-item-container > .ant-steps-item-tail::after),
  :deep(.ant-steps-item-process > .ant-steps-item-container > .ant-steps-item-tail::after),
  :deep(.ant-steps-item-wait > .ant-steps-item-container > .ant-steps-item-tail::after) {
    height: 2px !important;
    border-radius: 999px !important;
    background-color: var(--cpc-step-line) !important;
  }

  &.ant-steps-horizontal:not(.ant-steps-label-vertical) {

    /* 水平步骤：连线与圆心大致对齐 */
    :deep(.ant-steps-item-tail) {
      top: 16px !important;
      padding: 0 !important;
    }

    /* 标题右侧横线（与 Ant 的 title::after 同一节点，需压过 cssinjs） */
    :deep(.ant-steps-item-container > .ant-steps-item-content > .ant-steps-item-title::after) {
      height: 2px !important;
      border-radius: 999px !important;
      // background: var(--cpc-step-line) !important;
    }
  }

  :deep(.ant-steps-item-wait .ant-steps-item-title),
  :deep(.ant-steps-item-finish .ant-steps-item-title) {
    font-family: Sora, sans-serif !important;
    font-weight: 400 !important;
    font-style: normal !important;
    font-size: 16px !important;

    letter-spacing: 0 !important;
  }

  :deep(.ant-steps-item-wait .ant-steps-item-title) {
    color: var(--cpc-step-wait-text) !important;
  }

  :deep(.ant-steps-item-finish .ant-steps-item-title) {
    color: rgba(15, 6, 41, 0.55) !important;
  }

  :deep(.ant-steps-item-process .ant-steps-item-title) {
    color: var(--cpc-step-active) !important;
    font-family: Sora, sans-serif !important;
    font-weight: 500 !important;
    font-style: normal !important;
    font-size: 16px !important;

    letter-spacing: 0 !important;
  }
}

.notice {
  background: #f2f3f5;
  border-radius: 6px;
  padding: 10px 12px;
  margin-bottom: 18px;
  color: #4b5563;

  p {
    margin: 0;
    line-height: 1.6;
  }
}

.form {
  // max-width: 720px;
}

.title-input {
  height: 40px;
  width: 480px !important;
}


.field-title {
  .title-input-row {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-wrap: wrap;
    margin-top: 8px;

    :deep(.ant-input) {
      flex: 1;
      min-width: 200px;
    }

  }
}

.field {
  margin-bottom: 16px;
  margin-top: 16px;
  display: flex;
  flex-direction: column;

  label {
    font-family: Sora;
    font-weight: 500;
    font-size: 14px;
    leading-trim: NONE;
    line-height: 19px;
    letter-spacing: 0.4px;
    color: rgba(15, 6, 41, 1);

    small {
      margin-left: 4px;
      color: #9ca3af;
      font-weight: 400;
    }

    .label-required {
      color: #ff4d4f;
      margin-left: 2px;
      vertical-align: middle;
      line-height: 1;
    }
  }

  .small {
    font-family: Sora;
    font-weight: 500;
    font-style: Medium;
    font-size: 14px;
    leading-trim: NONE;
    line-height: 18px;
    letter-spacing: 0.3px;

  }
}

.field-error-text {
  margin: 6px 0 0;
  color: #ff4d4f;
  font-size: 12px;
  line-height: 1.4;
  width: 248px;
}

.field-error {

  :deep(.ant-input),
  :deep(.ant-input-number),
  :deep(.ant-picker) {
    border-color: #ff4d4f !important;
    box-shadow: none !important;
  }
}

.with-suffix {
  position: relative;

  margin-top: 16px;
  width: 248px;
  height: 32px;
}

.suffix {
  position: absolute;
  right: 10px;
  // bottom: 7px;
  color: #6b7280;
}

.tips {
  flex-shrink: 0;
  color: #9ca3af;
}

.platform-fee-note {
  display: flex;
  align-items: center;
  gap: 4px;
  font-family: Sora;
  font-weight: 400;
  font-style: Regular;
  font-size: 12px;
  leading-trim: NONE;
  line-height: 100%;
  letter-spacing: 0%;
  color: rgba(230, 130, 0, 1);
  padding-top: 6px;

  .icon-svg {
    width: 20px !important;
    height: 20px !important;
  }
}

.row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 16px;
  width: 800px;
}

.cpc-line {
  display: flex;
  align-items: center;
  gap: 12px;
  // margin-bottom: 10px;
  margin-top: 8px;
}

.item {
  display: flex;
  padding: 3px 4px;
  align-items: center;
  gap: 6px;
  border-radius: 6px;
  background: #f1f0f5;
  min-width: 111px;

  .icon {
    width: 20px !important;
    height: 20px !important;
  }

  .item-text {
    color: #0f0629;
    font-family: 'Sora';
    font-size: 13px;
    font-style: normal;
    font-weight: 400;
    letter-spacing: 0.3px;
    opacity: 0.7;
  }
}

.line-label {
  width: 120px;
  color: #4b5563;
}

.actions {
  border-radius: 0 0 8px 8px;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  gap: 12px;
  height: 64px;
  padding: 0 16px;
  align-items: center;
  position: sticky;
  bottom: 0;
  z-index: 999;
  background-color: #fff;
  margin-top: 2px;
  box-shadow: var(--section-box-shadow-6);
}

.actions-one {
  display: flex;
  align-items: center;
  gap: 8px;
}

.actions-two {
  display: flex;
  align-items: center;
  gap: 8px;
  justify-content: space-between;
  flex: 1;
}

.actions-split {
  justify-content: space-between;
  width: 100%;
}

.actions-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.btn-back {
  border-color: #d1d5db;
  color: #374151;
  background: #f9fafb;

  &:hover {
    border-color: #9ca3af !important;
    color: #111827 !important;
    background: #f3f4f6 !important;
  }
}

.btn-cancel {
  border: none;
  background-color: var(--yellow-5);
  color: var(--yellow-4);

  &:hover {
    background-color: var(--yellow-1) !important;
    color: var(--yellow-4) !important;
  }
}

.step-placeholder {
  padding: 24px 0;
  color: #374151;

  p {
    margin: 0 0 8px;
  }

  .muted {
    color: #9ca3af;
    font-size: 14px;
  }
}

.brand-select-row {
  margin-top: 8px;
  width: 480px;

  :deep(.brand-select) {
    width: 100%;
  }
}

.field-bonus-rule {
  border-radius: 8px;
  background-color: #F8F7FC;
  padding: 12px 16px;
}

.bonus-rule-label {
  display: flex;
  align-items: center;
  gap: 6px;
  margin-bottom: 8px;

}

.bonus-rule-label-text {
  font-family: Sora;
  font-weight: 600;
  font-size: 16px;
  leading-trim: NONE;
  line-height: 24px;
  letter-spacing: 0.4px;
  color: #0F0629;
}

.bonus-rule-help {
  width: 14px;
  height: 14px;
  color: rgba(15, 6, 41, 0.35);
  cursor: pointer;
}

.bonus-rule-type-row {
  position: relative;
  // display: flex;
  // align-items: center;
  // gap: 12px;
  // flex-wrap: wrap;
  // margin-top: 8px;
}

.bonus-rule-type-select {
  width: 180px;
}

.fixed-rate-input {}

.bonus-platform-fee {
  margin: 16px 0 0;
  font-size: 12px;
  line-height: 16px;
  color: #ff4d4f;
}

.tier-rates-panel {
  margin-top: 16px;
  padding: 16px 0 4px;
}

.tier-row {
  display: flex;
  align-items: flex-start;
  gap: 20px;
  margin-bottom: 16px;
  flex-wrap: nowrap;
}

.tier-label {
  font-family: Sora;
  font-weight: 500;
  font-style: Medium;
  font-size: 15px;
  leading-trim: NONE;
  line-height: 19px;
  letter-spacing: 0.4px;

  color: rgba(15, 6, 41, 0.9);
}

.tier-field {
  display: flex;
  flex-direction: column;
  gap: 8px;
  flex-shrink: 0;

  .tier-field-label {
    font-family: Sora, sans-serif;
    font-size: 14px;
    font-weight: 500;
    line-height: 19px;
    color: rgba(15, 6, 41, 0.9);
  }
}

.tier-field-rate {
  .tier-rate-input.with-suffix {
    position: relative;
    width: 248px;
    height: 32px;
    margin-top: 0;

    .suffix {
      right: 30px;
      // bottom: 7px;
    }
  }
}

.tier-input {
  width: 200px;

  :deep(.ant-input-number) {
    width: 100%;
    height: 40px;
    border-radius: 6px;
    border-color: #e8e5ed;
  }

  :deep(.ant-input-number-input) {
    // height: 38px;
    font-size: 14px;
  }

  :deep(.ant-input-number-handler-wrap) {
    opacity: 1;
    border-radius: 0 6px 6px 0;
  }
}

.tier-actions {
  display: flex;
  align-items: center;
  gap: 12px;
  // margin-left: auto;
  padding-top: 27px;
  flex-shrink: 0;
}

.tier-btn {
  height: 32px;
  padding: 0 14px;
  font-family: Sora, sans-serif;
  font-size: 14px;
  font-weight: 500;
  line-height: 30px;
  border-radius: 6px;
  background: #fff;
  cursor: pointer;
  white-space: nowrap;
  transition: opacity 0.2s;

  &:hover {
    opacity: 0.85;
  }
}

.tier-btn-add {
  color: #6C3DF2;
  background-color: #EFEAFC;
  border: 1px solid #8A64F4CC;

  &:disabled {
    opacity: 0.45;
    cursor: not-allowed;
  }
}

.tier-field-error {
  margin-top: 4px;
  margin-bottom: 0;
}

.tier-btn-delete {
  color: #EB4E3D;
  background-color: #FDEEEC;
  border: 1px solid #EB4E3DCC;
}

.field-bonus-rule {
  .with-suffix .suffix {
    right: 25px;
    bottom: 5px;
  }
}

.step-campaigns {
  // padding-bottom: 16px;

  :deep(.campaign-table) {
    .ant-table-tbody .ant-table-cell {
      font-family: Sora, sans-serif;
      font-weight: 500;
      font-size: 13px;
      line-height: 15px;
      letter-spacing: 0.3px;

      .status,
      .textStyle,
      .linkStyle {
        font-family: inherit;
        font-weight: inherit;
        font-size: inherit;
        line-height: inherit;
        letter-spacing: inherit;
      }
    }
  }
}

.campaign-notice {
  display: flex;
  gap: 8px;
  padding: 12px 16px;
  margin-bottom: 16px;
  background-color: var(--yellow-bg);
  border: 2px solid var(--yellow-5);
  border-radius: 8px;

  .campaign-notice-icon {
    flex-shrink: 0;
    margin-top: 4px;

    .icon {
      width: 20px;
      height: 20px;
      fill: var(--yellow-7);
    }
  }

  p {
    margin: 0;
    font-family: Sora, sans-serif;
    font-size: 14px;
    line-height: 24px;
    letter-spacing: 0.5px;
    color: rgba(0, 0, 0, 1);
  }
}

.campaign-toolbar {
  margin-bottom: 12px;
}

.linkStyle {
  // color: #7653da;
  text-decoration: underline;
}

.selected-campaigns-count {
  font-family: Sora, sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: rgba(15, 6, 41, 0.9);
}

:deep(.acc-campaign-locked-select-tooltip-wrap) {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  min-height: 22px;
  cursor: not-allowed;
}

.step-publishers {
  padding-bottom: 16px;
}

.publisher-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 20px;
  padding: 14px 16px;
  margin-bottom: 16px;
  border-radius: 8px;
  background: #f8f7fc;
}

.publisher-filter-label {
  font-family: Sora, sans-serif;
  font-size: 14px;
  font-weight: 500;
  color: #0f0629;
  margin-bottom: 8px;
}

.publisher-table {
  margin-bottom: 8px;

  :deep(.ant-table-tbody .ant-table-cell) {
    font-family: Sora, sans-serif;
    font-weight: 500;
    font-size: 13px;
    line-height: 15px;
    letter-spacing: 0.3px;
  }
}

.publisher-cell {
  display: flex;
  align-items: center;
  gap: 10px;
}

.publisher-name {
  font-weight: 600;
  color: #374151;
}
.filter-content{
  position: relative;
}
.text-ellipsis-2 {
  display: -webkit-box;
  line-clamp: 2;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  line-height: 1.4;
}
</style>
